export const NIGHT_FIELD_TRACK = {
  title: "Night on the Docks",
  artist: "Kevin MacLeod",
  src: "/audio/night-docks.m4a",
};

export function createFocusEngine() {
  const audio = new Audio(NIGHT_FIELD_TRACK.src);
  audio.loop = true;
  audio.preload = "auto";
  audio.volume = 0.7;
  audio.setAttribute("playsinline", "");
  audio.setAttribute("aria-hidden", "true");
  audio.hidden = true;
  document.body.appendChild(audio);

  return {
    audio,
    start() {
      if (audio.readyState < 2) audio.load();
      return audio.play();
    },
    stop() {
      audio.pause();
    },
    dispose() {
      audio.pause();
      audio.remove();
    },
  };
}
